import {connect} from 'react-redux';
import QCReportsContainer from './QCReportsNotesContainer';
import {
    QCReportsNotesState,
    QCReportsReasonsState,
} from '../QCReportsReasonsTypes';
import {
    qcReportsNotesSetAction,
    resetQcReportsNotesAction,
    deleteQcReportNoteAction,
    editQcReportsNoteAction,
} from './Redux/QCReportsNotesActions';

interface State {
    qcJobs: {
        qcReportsNotes: QCReportsNotesState,
        qcReportsReasons: QCReportsReasonsState,
    }
}

export const mapState = (state: State) => ({
    qcReportsReasons: state.qcJobs.qcReportsReasons,
    qcReportsNotes: state.qcJobs.qcReportsNotes,
});

export const mapDispatch = {
    qcReportsNotesSet: qcReportsNotesSetAction,
    resetQcReportsNotes: resetQcReportsNotesAction,
    deleteQcReportNote: deleteQcReportNoteAction,
    editQcReportsNote: editQcReportsNoteAction,
};

export default connect(mapState, mapDispatch)(QCReportsContainer);
